<template>
  <div>
      <el-dialog :visible.sync="showmodal" width="35%" @close="$emit('close-modal')">
          <div class="text-center modals-wrapper">
              <p class="text">You are currently operating from <b>{{ this.$store.getters?.currentLocation?.location?.locationName || "" }}</b> 
                <span v-if="this.$store.getters?.currentLocation?.location?.locationCode">[<b>{{ this.$store.getters?.currentLocation?.location?.locationCode || ""}}</b>]</span>.
                        To switch to a different terminal, use the terminal feature on the top navigation</p>

              <button @click="closeModal" class="close_btn">Close</button>
          </div>
      </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    showmodal: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async pauseDispatch() {
      this.loading = true;
    },
    closeModal() {
      this.$emit("close-modal");
    }
  },
};
</script>

<style lang="scss" scoped>
.button {
  background: #fcc210;
  color: var(--primaryblue);
  width: 40%;
  font-weight: 500;
}
.new-address-button {
  text-decoration-line: underline;

  color: #da9601;
}

.radio-label span::after {
  background: #bec4d5;
}
.modals-wrapper{
    button{
        background-color : #FCC210;
        color : #10233E;
        font-weight : 600;
    }
}
 .close_btn{
  @apply mt-6 rounded-md  px-8 text-base py-2.5;
}
.text{
  @apply mt-5 text-base !break-normal
}
</style>
